<div class="Home">
  <header class="sticky-top">
    <div class="header_title text-center py-2">
      <span>{{ $t('header.title') }}</span>
      <LanguageSwitcher />
    </div>
  </header>
  <b-offcanvas v-model="state_data.sidemenu" :title="$t('menu.title')" style="width:75%;"
        header-class="bg-secondary text-light" body-class="px-0 py-0">
    <b-list-group class="mx-0 px-0">
      <b-list-group-item button @click="edit()">{{ $t('menu.edit') }}</b-list-group-item>
      <b-list-group-item button @click="retire_open()">{{ $t('menu.retire') }}</b-list-group-item>
      <b-list-group-item button @click="signout_open()">{{ $t('menu.signout') }}</b-list-group-item>
    </b-list-group>
  </b-offcanvas>
  
  <!-- ローディング -->
  <loading v-model:active="loader.is_loading" :is-full-page="loader.is_full_page"></loading>
  <!-- メッセージ -->
  <b-alert v-model="message.is_alert" dismissible :variant="message.variant">{{ message.message }}</b-alert>

  <b-container class="px-0">
    <div class="text-center mt-4">
      <img :alt="$t('alt.banner')" :src="bannerImage" class="img-fluid" />
    </div>
    <div class="text-center mt-4 mx-4">
      <div class="markdown-body" v-html="bind_data.markdowntext"></div>
    </div>
    <div class="text-center mt-4 mx-4">
      <a href="https://play.google.com/store/apps/details?id=com.shadowsworks.chattyreminders" target="_blank"><img src="../../assets/Google_Play_Store_badge_EN.svg" :alt="$t('alt.google_play')"></a>
    </div>

    <footer class="sticky-bottom">
      <b-row>
        <b-col class="d-grid gap-2" lg="4" md="12">
          <b-button variant="outline-primary" class="mt-2 mx-4 btn" size="sm" @click="qa()">{{ $t('nav.faq') }}</b-button>
        </b-col>
        <b-col class="d-grid gap-2" lg="4" md="12">
          <b-button block variant="outline-primary" class="mt-2 mx-4 btn" size="sm" @click="privacy_policy()">{{ $t('nav.privacy_policy') }}</b-button>
        </b-col>
        <b-col class="d-grid gap-2" lg="4" md="12">
          <b-button block variant="outline-primary" class="mt-2 mx-4 btn" size="sm" @click="terms_of_service()">{{ $t('nav.terms_of_service') }}</b-button>
        </b-col>
      </b-row>
      <br>
    </footer>
  </b-container>
  
</div>